const DefaultCheckoutButtonHeight = 40;

export default DefaultCheckoutButtonHeight;
